import { useTranslation } from 'react-i18next';
import type { ProductLengthPickerLabels } from '~/components/common/ProductLengthPicker';

export function useLengthPickerLabels(
  label: string,
  trigger: string
): ProductLengthPickerLabels {
  const { t } = useTranslation('general');
  return {
    label,
    trigger,
    searchPlaceholder: t('product_length_picker.length_search'),
    searchLabel: t('product_length_picker.length_search'),
    loading: t('product_length_picker.length_loading'),
    error: t('product_length_picker.length_error'),
    emptyTitle: t('product_length_picker.length_empty_title'),
    emptyMessage: t('product_length_picker.length_empty_message'),
    noResultsTitle: t('product_length_picker.length_no_results_title'),
    noResultsMessage: t('product_length_picker.length_no_results_message'),
  };
}
